import React, { useContext, useEffect } from "react";
import useTitle from "../Hooks/useTitle";
import ToastContext from "../Context/toastContext";

import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import axiosClient from "../Utils/axiosClient";

const UnsubscribePage = () => {
  const { userId } = useParams();
  const { phoneNumber } = useParams();
  const { showToast } = useContext(ToastContext);
  const { t } = useTranslation();

  useTitle(`BizReach`);

  const sendUnsubscribe = async () => {
    try {
      const response = await axiosClient.post(
        `/no-msg/${userId}/${phoneNumber}`
      );
      if (!response.status === 200) {
        showToast(
          `${t("Error")}: ${response.statusText}`,
          "Http status :",
          response.status
        );
      }
    } catch (error) {
      showToast(`${t("Error")} : ${error.message}`, `${t("Error")}`);
    }
  };

  useEffect(() => {
    sendUnsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="unsubscribe-container">
      <div className="containers">
        <div className="left-container">
          <img className="logo-big" src="/images/big.png" alt="login-xl" />
          <img className="logo-small" src="/images/logo.png" alt="login-sm" />
        </div>
        <div className="right-container">
          <div className="no-msg-container">
            <h1 className="unsub-h1">{t("message.unsubscribe.title")}</h1>
            <p className="unsub-p">{t("message.unsubscribe.info")}</p>

            {/* Bilgilendirme ve Tanıtım */}
            <div className="info-container">
              <p className="unsub-p">{t("message.unsubscribe.finalMessage")}</p>
              <button
                className="cta-btn"
                onClick={() => (window.location.href = "/contactus")}
              >
                {t("message.unsubscribe.ctaText")}
              </button>
            </div>

            {/* Firma Tanıtım Bölümü */}
            <div className="company-info">
              <h2 className="unsub-h2">
                {t("message.unsubscribe.companyTitle")}
              </h2>
              <p className="unsub-p">{t("message.unsubscribe.companyInfo")}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnsubscribePage;
